import _extends from "@babel/runtime-corejs3/helpers/extends";
import { features } from '@kdcloudjs/table';
function useRowDetail(pipeline, rowDetail) {
  if (rowDetail) {
    pipeline.use(features.rowDetail(_extends({}, rowDetail)));
  }
}
export default useRowDetail;